import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";
import { z } from "zod";

import { profileDataModelSchema } from "@/schemas/profile";
import type { FormAnswerField } from "@/types/form";
import type {
  Profile,
  UpdateProfileDetailParams,
  UpdateProfileSummaryParams,
} from "@/types/profile";
import type { CareplanSurvey } from "@/types/survey";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getProfiles = async ({ queryBuilder }: { queryBuilder?: QueryBuilder }) => {
  const { data: response } = await privateAPI.get<ServiceResponse<Profile[]>>(
    "/profiles?" + queryBuilder?.build(),
  );

  return {
    ...response,
    data: z.array(profileDataModelSchema).parse(response.data),
  };
};

export const getProfile = async (id: Profile["id"]) => {
  const response = await privateAPI.get<ServiceResponse<Profile>>(`/profiles/${id}`);

  return profileDataModelSchema.parse(response.data.data);
};

export const getProfileDetail = async (id: Profile["id"]) => {
  const response = await privateAPI.get<ServiceResponse<FormAnswerField[]>>(
    `/profiles/${id}/detail`,
  );

  return response.data.data;
};

export const updateProfileSummary = async (data: UpdateProfileSummaryParams) => {
  const response = await privateAPI.put<ServiceResponse<Profile>>(`/profiles/${data.id}`, data);

  return profileDataModelSchema.parse(response.data.data);
};

export const updateProfileDetail = async (data: UpdateProfileDetailParams) => {
  const response = await privateAPI.put<ServiceResponse<FormAnswerField[]>>(
    `/profiles/${data.id}/detail`,
    data.details,
  );

  return response.data;
};

export const getProfileSurveys = async (id: Profile["id"]) => {
  const response = await privateAPI.get<ServiceResponse<CareplanSurvey[]>>(
    `/profiles/${id}/surveys`,
  );

  return response.data.data;
};
